<template>
  <f7-page name="login">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title" v-on:click="goIndex()">
        로그인
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- Page content-->
    <div class="view">
      <div class="page login-screen-page page-current">
        <div class="page-content login-screen-content" style="padding:0">
          <div class="list">
            <ul>
							<li class="text-align-center">
								<img src="static/icons/512x512.png" style="width:40%;">
							</li>
							<li>
								<h2 class="text-align-center no-margin">사용자 로그인</h2>
							</li>
              <li>
                <div class="item-content item-input item-input-with-value">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <input
                        name="userId"
                        ref="userId"
                        type="text"
                        placeholder="사용자 ID"
                        class="input-with-value"
												v-model="userId"
                        @keyup.enter="$refs.userPw.focus()"
                      />
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input item-input-with-value">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <input
                        name="userPw"
                        ref="userPw"
                        type="password"
                        placeholder="비밀번호"
                        class="input-with-value"
												clear-button
												v-model="userPw"
                        @keyup.enter="login"
                      />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <f7-block>
            <f7-row>
              <f7-col width="50">
                <label class="checkbox"><input type="checkbox" v-model="autoLogin"><i class="icon-checkbox"></i></label> 자동 로그인
              </f7-col>
              <f7-col width="50">
                <f7-button fill raised v-on:click="login">로그인</f7-button>
              </f7-col>
            </f7-row>
            <f7-row class="margin-top">
              <f7-col width="50">
                <f7-link href="/select_regist" data-view=".view-main" data-clear-previous-history="true" class="item-link panel-close">
									회원가입
								</f7-link>
              </f7-col>
              <f7-col class="text-align-right" width="50">
								 <f7-link href="/idpw" data-view=".view-main" data-clear-previous-history="true" class="item-link panel-close">
								 	ID/PW 찾기
								 </f7-link>
                
              </f7-col>
            </f7-row>
          </f7-block>
				
        </div>
				
        <div class="toolbar toolbar-bottom no-shadow aurora">
          <div class="toolbar-inner">
            <small><span data-view=".view-main" data-clear-previous-history="true" class="link" style="color:#626262" v-on:click="openInfo('use');">이용약관</span></small>
            <small><span data-view=".view-main" data-clear-previous-history="true" class="link item-content popup-open" style="color:#626262" data-popup=".business-view-popup">사업자정보확인</span></small>
            <small><span data-view=".view-main" data-clear-previous-history="true" class="link" style="color:#626262" v-on:click="openInfo('indi');">개인정보취급방침</span></small>
          </div>
        </div>
      </div>
	
		
			
    </div>

    <div class="popup business-view-popup" id="business-view-popup">
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">사업자 정보</div>
							<div class="right">								
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content">	
            <div class="card card-outline">
              <div class="card-content card-content-padding">
                <div class="list">
                  <ul>        
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">상호명 : </div>
                        <div class="item-after">(주)오투라인</div>
                      </div>
                    </li>   
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">대표이사 : </div>
                        <div class="item-after">안남재</div>
                      </div>
                    </li>
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">주소 : </div>
                        <div class="item-after">서울시 구로구 구로3동 212-30 에이스트윈타워 2차 603호</div>
                      </div>
                    </li>
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">사업자 등록번호 : </div>
                        <div class="item-after">105-86-22701 </div>
                      </div>
                    </li>       
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">통신판매업 신고 : </div>
                        <div class="item-after">제 2020-서울구로-2506 호</div>
                      </div>
                    </li>         
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">대표번호 : </div>
                        <div class="item-after">1600-5290</div>
                      </div>
                    </li>         
                    <li class="item-content">                      
                      <div class="item-inner">
                        <div class="item-title">FAX : </div>
                        <div class="item-after">02-2109-5290</div>
                      </div>
                    </li>                                   
                  </ul>
                </div>                
              </div>              
            </div>
            <div class="text-align-right margin-right">
              Copyright(C) O2LINE ALL RIGHTS RESERVED
            </div>
					</div>					
				</div>
			</div>			
		</div>	

	
  </f7-page>
</template>

<script>
	
  import MODULE from '../../js/common/module.js'
  import CONST from '../../js/common/constant.js'
  import AUTH from '../../js/common/auth.js'
  import PAGES from '../../js/pages.js'
  import API from '../../js/common/api.js'

  export default {
    data() {
      return {
        userId: '',
        userPw: '',
        autoLogin: false
      }
    },
    mounted() {
      let _this = this;

      if (_this.$f7route.context) {
       
       var forceCode = _this.$f7route.context.forceCode;

        if (forceCode == CONST.resultCode.USER_AUTH_EXPIRED) {
          MODULE.DialogBox.message("에러", "사용자 사용권 기간이 만료되었습니다.<br/>사용권 결제후 이용하세요.");
        } else if (forceCode == CONST.resultCode.COMPANY_AUTH_EXPIRED) {
          MODULE.DialogBox.message("에러", "고객사 사용권 기간이 만료되었습니다.<br/>선생님께 문의하세요.");
        } else if (forceCode == CONST.resultCode.TOKEN_MISMATCH) {
          MODULE.DialogBox.message("에러", "동일한 계정이 로그인되어<br/>자동 로그아웃 되었습니다.<br/>다시 로그인하세요.");
        }
      }
    },
    methods: {
			login() {
        let _this = this;

        if (MODULE.Util.isEmpty(this.userId)) {
          MODULE.DialogBox.infoToast("사용자ID를 입력하세요.");
          this.$refs.userId.focus();
          return;
        }

        if (MODULE.Util.isEmpty(this.userPw)) {
          MODULE.DialogBox.infoToast("비밀번호를 입력하세요.");
          this.$refs.userPw.focus();
          return;
        }


				let param = {
					solutionId: "bjsup",
					companyKey: 0,					
					userId: this.userId,
          userPw: this.userPw,
          autoLogin: this.autoLogin
				};

        API.ajaxRequest({
					url: API.loginUrl(),
					data: param
				}).then(function (data) {

          AUTH.createUserInfo(data);

          if (data.accessToken) {
						AUTH.setAccessToken(data.accessToken);
						API.setAccessTokenHeader(data.accessToken);
          }
          
          _this.$utils.nextTick(function() {
            const userMainPage = AUTH.getUserMainPage();
            var param = {
						  firstLogin : true
						}
            PAGES.goPage(userMainPage, param);  
          });
				}).catch(function (code) {
          if (code == CONST.resultCode.NOT_FOUND) {
            MODULE.DialogBox.message("에러", "존재하지 않는 사용자 계정입니다.");
          } else if (code == CONST.resultCode.NOT_EQUALS) {
            MODULE.DialogBox.message("에러", "사용자 비밀번호가 일치하지 않습니다.");
          } else if (code == CONST.resultCode.LOCKED) {
            MODULE.DialogBox.message("에러", "로그인 시도 횟수 초과로 계정이 잠겼습니다. 5분후에 다시 시도하세요.");
          } else {
            MODULE.UITool.catchBlock(code, PAGES, AUTH);
          }
				});
      },
      openInfo(type) {       
        let url = "";
        let param = {};
        if(type == "use") {
          url = PAGES.USE_INFO_PAGE;          
        } else {
          url = PAGES.INDI_INFO_PAGE;        
        }
        
        PAGES.popPage(url,param); 
      },
      goIndex() {
        location.href="/";
      }     
    }
  }
</script>